import cn from 'classnames'
import styles from './filter-tabs.module.scss'

/**
 * @param {{
 *   value: string,
 *   options: Array<{value: string, label: string}>,
 *   onChange: (value: string) => void,
 *   className?: string
 * }} props
 */
export function FilterTabs({value, options, onChange, className}) {
    return (
        <div className={cn(styles.group, className)} role="tablist">
            {options.map(option => {
                const active = option.value === value
                return (
                    <button
                        key={option.value}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        className={cn(styles.cell, {[styles.active]: active})}
                        onClick={() => onChange(option.value)}
                    >
                        {option.label}
                    </button>
                )
            })}
        </div>
    )
}
